import axios from '../services/ApiService';
import { toast } from 'react-hot-toast';

export const useReports = () => {
  
    /**
   * Downloads a report by making a POST request to the given endpoint.
   *
   * @param {string} endpoint - The API path (e.g. '/generateAssessmentCertificate')
   * @param {*} payload - The request body to send to the endpoint
   * @param {string} filename - The name to save the downloaded file as
   * @param {string} [mimeType='application/pdf'] - The MIME type of the file
   */
  const downloadReport = async (endpoint, payload, filename, mimeType = 'application/pdf') => {
    try {
      toast.loading('Generating report...', { id: 'reportGen' });

      const response = await axios.post(endpoint, payload, {
        responseType: 'blob',
      });

      const blob = new Blob([response.data], { type: mimeType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();

      toast.success('Report downloaded!', { id: 'reportGen' });
    } catch (error) {
      toast.error('Failed to download report.', { id: 'reportGen' });
      console.error(`Download error for ${endpoint}:`, error);
    }
  };

  return {
    downloadReport,
  };
};
